/*
 * Copyright 2022 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package com.deange.nastychristmas.ui.icons

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.materialIcon
import androidx.compose.material.icons.materialPath
import androidx.compose.ui.graphics.vector.ImageVector

val Icons.Filled.VisibilityOff: ImageVector
  get() {
    if (_visibilityOff != null) {
      return _visibilityOff!!
    }
    _visibilityOff = materialIcon(name = "Filled.VisibilityOff") {
      materialPath {
        moveTo(12.0f, 7.0f)
        curveToRelative(2.76f, 0.0f, 5.0f, 2.24f, 5.0f, 5.0f)
        curveToRelative(0.0f, 0.65f, -0.13f, 1.26f, -0.36f, 1.83f)
        lineToRelative(2.92f, 2.92f)
        curveToRelative(1.51f, -1.26f, 2.7f, -2.89f, 3.43f, -4.75f)
        curveToRelative(-1.73f, -4.39f, -6.0f, -7.5f, -11.0f, -7.5f)
        curveToRelative(-1.4f, 0.0f, -2.74f, 0.25f, -3.98f, 0.7f)
        lineToRelative(2.16f, 2.16f)
        curveTo(10.74f, 7.13f, 11.35f, 7.0f, 12.0f, 7.0f)
        close()
        moveTo(2.0f, 4.27f)
        lineToRelative(2.28f, 2.28f)
        lineToRelative(0.46f, 0.46f)
        curveTo(3.08f, 8.3f, 1.78f, 10.02f, 1.0f, 12.0f)
        curveToRelative(1.73f, 4.39f, 6.0f, 7.5f, 11.0f, 7.5f)
        curveToRelative(1.55f, 0.0f, 3.03f, -0.3f, 4.38f, -0.84f)
        lineToRelative(0.42f, 0.42f)
        lineTo(19.73f, 22.0f)
        lineTo(21.0f, 20.73f)
        lineTo(3.27f, 3.0f)
        lineTo(2.0f, 4.27f)
        close()
        moveTo(7.53f, 9.8f)
        lineToRelative(1.55f, 1.55f)
        curveToRelative(-0.05f, 0.21f, -0.08f, 0.43f, -0.08f, 0.65f)
        curveToRelative(0.0f, 1.66f, 1.34f, 3.0f, 3.0f, 3.0f)
        curveToRelative(0.22f, 0.0f, 0.44f, -0.03f, 0.65f, -0.08f)
        lineToRelative(1.55f, 1.55f)
        curveToRelative(-0.67f, 0.33f, -1.41f, 0.53f, -2.2f, 0.53f)
        curveToRelative(-2.76f, 0.0f, -5.0f, -2.24f, -5.0f, -5.0f)
        curveToRelative(0.0f, -0.79f, 0.2f, -1.53f, 0.53f, -2.2f)
        close()
        moveTo(11.84f, 9.02f)
        lineToRelative(3.15f, 3.15f)
        lineToRelative(0.02f, -0.16f)
        curveToRelative(0.0f, -1.66f, -1.34f, -3.0f, -3.0f, -3.0f)
        lineToRelative(-0.17f, 0.01f)
        close()
      }
    }
    return _visibilityOff!!
  }

private var _visibilityOff: ImageVector? = null
